import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import PolicyLink from './PolicyLink'
import config from 'config'

const {
  legal: { terms_conditions, privacy_policy, host_terms },
} = config

const PrivacyTerms = ({ forHost, className }) => (
  <p className={classnames('mt-3 text-xs text-center', className)}>
    By clicking continue, you agree to our{' '}
    <PolicyLink href={forHost ? host_terms : terms_conditions}>Terms of Service</PolicyLink> &{' '}
    <PolicyLink href={privacy_policy}>Privacy Policy</PolicyLink>.
  </p>
)

PrivacyTerms.propTypes = {
  forHost: PropTypes.bool,
  className: PropTypes.string,
}

PrivacyTerms.defaultProps = {
  forHost: false,
}

export default PrivacyTerms
